import { defineMessages } from '@jutro/locale';

export default defineMessages({
    initiatorLabel: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReportAdditionalFilter.Initiator',
        defaultMessage: 'Initiator'
    },
    allInitiators: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReportAdditionalFilter.All Initiators',
        defaultMessage: 'All Initiators'
    },
    cancelReason: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReportAdditionalFilter.Cancel Reason',
        defaultMessage: 'Cancel Reason'
    },
    allReasons: {
        id: 'ml.gateway.views.ActivityReports.MLCancellationsReportAdditionalFilter.All Reasons',
        defaultMessage: 'All Reasons'
    }
});
